export default __webpack_public_path__ + "static/media/resetBg.19588594.jpg";